// src/pages/hr/HRExpenses.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRExpenses() {
  return (
    <HRComingSoon
      icon="💰"
      title="Expense Management"
      description="Manage employee expense claims, reimbursements, approval workflows, category breakdown, and expense reports. Coming soon."
    />
  );
}
